import { useQuery } from '@tanstack/react-query';
import { stripeAdminApi, type StripeDashboardMode } from '../api/stripeAdminApi';

/** Frais de plateforme (markup Affinicar) facturés au vendeur pour la société. */
export const usePlatformFees = (
  societyId: string | undefined,
  mode: StripeDashboardMode = 'self',
) =>
  useQuery({
    queryKey: ['stripe-admin', 'platform-fees', mode, societyId],
    queryFn: () => stripeAdminApi.getPlatformFees(societyId as string, mode),
    enabled: !!societyId,
    staleTime: 60_000,
  });
